import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { useSeo } from "../hooks/useSeo";
import { LOGO } from "../lib/site";
import { inputCls, Field } from "../components/QuoteForm";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useSeo({ title: "MAKO Admin" });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await http.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="flex min-h-screen items-center justify-center bg-[#F5F5F2] px-6 py-20"
    >
      <div className="w-full max-w-md border border-[#111111]/10 bg-white p-9 lg:p-12">
        <Link to="/">
          <img src={LOGO.primary} alt="MAKO Mats" className="h-10 w-auto" />
        </Link>
        <p className="mako-label mt-10 text-[#0F4C81]">Admin access</p>
        <h1 className="mt-4 font-display text-2xl font-bold uppercase tracking-tight text-[#111111]">
          Sign in
        </h1>

        <form onSubmit={submit} className="mt-9 space-y-6">
          <Field label="Email" required>
            <input
              className={inputCls}
              type="email"
              data-testid="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@makomats.com"
              required
            />
          </Field>
          <Field label="Password" required>
            <input
              className={inputCls}
              type="password"
              data-testid="admin-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </Field>

          {error && (
            <p data-testid="admin-login-error" className="text-xs text-[#b3261e]">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-3 bg-[#0F4C81] px-6 py-4 text-[0.6875rem] font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-[#1463A5] disabled:opacity-60"
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            {busy ? "Signing in" : "Sign in"}
          </button>
        </form>

        <Link
          to="/"
          className="mako-label mt-10 inline-block text-[#7A7F85] transition-colors duration-300 hover:text-[#0F4C81]"
        >
          Back to website
        </Link>
      </div>
    </div>
  );
}
